// store.js
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from '../reducers/index.ts';
//import vcfDataReducer from '../reducers/vcfDataReducer.ts';

//export default createStore(vcfDataReducer, applyMiddleware(thunk));
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;